import { useState } from 'react';

import GenericPropertyInput from '../../../FlowDesigner/Components/Inputs/GenericPropertyInput';
import { TableColumnActionModel } from '../../Models/TableColumnModel';
import ActionsInputContent from './ActionsInputContent';
import { ActionsInputDialog } from './ActionsInputDialog';

type ActionsInputProps = {
	actions: TableColumnActionModel[] | undefined;
	onActionsChange: (actions: TableColumnActionModel[] | undefined) => void;
};

export default function ActionsInput({ actions, onActionsChange }: ActionsInputProps) {
	const [open, setOpen] = useState(false);

	return (
		<GenericPropertyInput value={actions} onValueChange={onActionsChange} onOpen={() => setOpen(true)}>
			<ActionsInputContent value={actions} />
			{open && <ActionsInputDialog open={open} setOpen={setOpen} actions={actions} onActionsChange={onActionsChange} />}
		</GenericPropertyInput>
	);
}
